var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_647_8842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0209 78.6933C61.7515 78.6933 79.3676 61.0772 79.3676 39.3466C79.3676 17.6161 61.7515 0 40.0209 0C18.2904 0 0.674316 17.6161 0.674316 39.3466C0.674316 61.0772 18.2904 78.6933 40.0209 78.6933Z",
    fill: "#D1D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8819 46.4162C23.6005 38.1384 16.7085 30.6469 25.3808 15.5568C28.9528 9.34238 34.4091 5.24297 40.0452 6.63094C45.6814 5.24297 51.1376 9.34163 54.7096 15.5568C63.382 30.6469 56.4899 38.1384 53.2086 46.4162L40.0452 46.4488L26.8819 46.4162Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8749 59.3572C17.4636 60.0212 16.4361 65.6718 15.3008 69.9556C22.057 75.4187 30.6557 78.6925 40.021 78.6925C49.3862 78.6925 57.9857 75.4187 64.7411 69.9556C63.6051 65.6718 62.5784 60.0212 62.167 59.3572C55.8457 49.1504 46.1025 53.6065 45.4385 41.9268C45.4385 41.9268 42.3044 44.2656 39.9109 44.2876C37.5174 44.3088 34.6011 42.0747 34.6011 42.0747C33.9386 53.7446 24.1925 49.1588 17.8756 59.3572H17.8749Z",
    fill: "#FED298"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6078 43.5758C45.5296 43.0643 45.4712 42.5164 45.4378 41.9268C45.4378 41.9268 42.3036 44.2656 39.9102 44.2876C37.5167 44.3088 34.6004 42.0747 34.6004 42.0747C34.5662 42.675 34.507 43.2305 34.4266 43.7496C34.488 43.7981 34.5488 43.8475 34.611 43.8953L34.6102 43.9036C34.7946 44.0637 37.5964 46.4739 39.9102 46.4496C42.224 46.4739 45.0257 44.0645 45.2101 43.9036V43.8953C45.3459 43.7913 45.478 43.6843 45.6085 43.5765L45.6078 43.5758Z",
    fill: "#F0BA7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6102 42.0816C34.7946 42.2205 37.5964 44.3081 39.9102 44.2869C42.224 44.3081 45.0257 42.2205 45.2101 42.0816C48.7077 40.0425 51.5778 34.03 50.9297 27.5143C50.3993 22.1772 44.625 30.0034 40.6038 18.9907C34.9122 30.9133 29.5068 23.8604 28.8899 28.3787C28.2107 33.3569 31.0056 39.6206 34.6095 42.0808L34.6102 42.0816Z",
    fill: "#FED298"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0175 50.4301C26.573 52.2703 20.2721 52.3257 17.8741 56.18C17.4567 56.8516 16.4087 65.074 15.2552 69.9201C22.0183 75.4045 30.6345 78.6927 40.0202 78.6927C49.4059 78.6927 58.0221 75.4045 64.7851 69.9201C63.6317 65.0747 62.4577 56.9154 62.1663 56.18C60.5742 52.1649 53.2048 51.9971 49.7565 50.1455C44.3958 69.5953 36.4057 70.9218 30.0183 50.4316L30.0175 50.4301Z",
    fill: "#E28086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3146 48.4971C32.0908 54.5483 33.119 63.1212 39.9094 65.3121C33.5174 65.5792 29.3687 56.3688 24.644 53.9564L32.3146 48.4978V48.4971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8844 48.4971C48.1196 54.5483 47.039 63.1212 39.9094 65.3121C46.6216 65.5792 50.9775 56.3688 55.939 53.9564L47.8844 48.4978V48.4971Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_647_8842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.6925,
    height: 78.6925,
    fill: "white",
    transform: "translate(0.674316)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/Avatar4.c0f3330e9e7104d00ccab850c5cf9d6b.svg";
export { ForwardRef as ReactComponent };